module.exports = __webpack_public_path__ + "media/images/blog/bg-magazine-84f04745e04b30050e2f9b1e9b9e9e1c.jpg";